
namespace RecordShield.Workspace {
    
    @Serenity.Decorators.registerClass()
    export class SerialKeyAnalyticsGrid extends Serenity.EntityGrid<SerialKeyAnalyticsRow, any> {
        protected getColumnsKey() { return 'Workspace.SerialKeyAnalytics'; }
        protected getDialogType() { return SerialKeyAnalyticsDialog; }
        protected getLocalTextPrefix() { return SerialKeyAnalyticsRow.localTextPrefix; }
        protected getService() { return SerialKeyAnalyticsService.baseUrl; }
        private nextId = 1;
        constructor(container: JQuery) {
            super(container);
        }
        protected onViewProcessData(response: Serenity.ListResponse<RecordShield.Workspace.SerialKeyAnalyticsRow>) {
            response = super.onViewProcessData(response);
            var map: { [SerialKeysGenerated: string]: number; } = {};
            var SerialKeysGenerated = 'Serial Key';
            var totalSerailkeys = 0;
            var totalCredit = 0;
            for (var x of response.Entities) {     
                if (isNaN(totalSerailkeys))
                    totalSerailkeys = 0;
                totalSerailkeys = (totalSerailkeys + x.SerialKeysGenerated)
                if (isNaN(totalCredit))
                    totalCredit = 0;
                totalCredit = (totalCredit + x.CreditConsumed)
            }
            var htmlString = 'Total Serialkeys:' + totalSerailkeys + ',Total Credits Consumed:' + totalCredit;
           
            $("#divStatusDetails")[0].innerHTML = htmlString;
            return response;
            
        }

        protected getQuickFilters() {
            debugger;
            var filters = super.getQuickFilters();

            // we create a date-range quick filter, which is a composite
            // filter with two date time editors
            var InvoiceDate = this.dateRangeQuickFilter('InsertDate', 'Insert Date');

            // need to override its handler, as default date-range filter will set Criteria parameter of list request.
            // we need to set StartDate and EndDate custom parameters of our CustomerGrossSalesListRequest
            InvoiceDate.handler = args => {

                // args.widget here is the start date editor. value of a date editor is a ISO date string
                var start = args.widget.value;

                // to find end date editor, need to search it by its css class among siblings
                var end = args.widget.element.nextAll('.s-DateEditor')
                    .getWidget(Serenity.DateEditor).value;

                (args.request as SerialKeyAnalyticsListRequest).StartDate = start;
                (args.request as SerialKeyAnalyticsListRequest).EndDate = end;

                // active option controls when a filter editor looks active, e.g. its label is blueish
                args.active = !Q.isEmptyOrNull(start) || !Q.isEmptyOrNull(end);
            };

            filters.push(InvoiceDate);

            return filters;
        }
        protected getButtons() {
            var buttons = [];

            buttons.push(Common.ExcelExportHelper.createToolButton({
                grid: this,
                service: SerialKeyAnalyticsService.baseUrl + '/ListExcel',
                onViewSubmit: () => this.onViewSubmit(),
                separator: true
            }));

            buttons.push(Common.PdfExportHelper.createToolButton({
                grid: this,
                onViewSubmit: () => this.onViewSubmit()
            }));

            return buttons;
        }

       
    }
}